/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * An organizer's verdict on a tolerance-accepted or flagged result.
 * @export
 */
export const ReviewDecision = {
    Confirmed: 'confirmed',
    Rejected: 'rejected'
} as const;
export type ReviewDecision = typeof ReviewDecision[keyof typeof ReviewDecision];


export function instanceOfReviewDecision(value: any): boolean {
    for (const key in ReviewDecision) {
        if (Object.prototype.hasOwnProperty.call(ReviewDecision, key)) {
            if (ReviewDecision[key as keyof typeof ReviewDecision] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ReviewDecisionFromJSON(json: any): ReviewDecision {
    return ReviewDecisionFromJSONTyped(json, false);
}

export function ReviewDecisionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReviewDecision {
    return json as ReviewDecision;
}

export function ReviewDecisionToJSON(value?: ReviewDecision | null): any {
    return value as any;
}

export function ReviewDecisionToJSONTyped(value: any, ignoreDiscriminator: boolean): ReviewDecision {
    return value as ReviewDecision;
}

